import {
  STUDENT_SET_AUDIO_ERROR,
  STUDENT_SET_AUDIO_LOADING,
  STUDENT_SET_AUDIO_SUCCESS,
  STUDENT_SET_LESEN_ERROR,
  STUDENT_SET_LESEN_LOADING,
  STUDENT_SET_LESEN_SUCCESS,
  STUDENT_SET_MCQ_ERROR,
  STUDENT_SET_MCQ_LOADING,
  STUDENT_SET_MCQ_QUESTIONS,
  STUDENT_SET_STATUS_ERROR,
  STUDENT_SET_STATUS_LOADING,
  STUDENT_SET_STATUS_SUCCESS,
  STUDENT_SET_BUNDLE_LOADING,
  STUDENT_SET_BUNDLE_SUCCESS,
  STUDENT_SET_BUNDLE_ERROR,
} from "../Actions/types";

const initialState = {
  // MCQ page
  loading: false,
  error: null,
  mcqQuestions: [],
  currentPage: 0,
  totalPages: 0,
  size: 20,
  totalElements: 0,
  bundle: null,
  bundleLoading: false,
  bundleError: null,

  // Lesen
  lesenPassage: null, // { id, title, content, questions: [] }
  lesenQuestions: [],

  // Audio page
  audioLoading: false,
  audioError: null,
  audioQuestions: [],
  audioPage: 0,
  audioTotalPages: 0,
  audioSize: 20,
  audioTotalElements: 0,

  // Placement test STATUS
  statusLoading: false,
  statusError: null,
  status: {
    hasSession: false,
    inProgress: false,
    submitted: false,
    blacklisted: false,
  },
};

const studentPlacementReducer = (state = initialState, action) => {
  switch (action.type) {
    // MCQ
    case STUDENT_SET_MCQ_LOADING:
      return { ...state, loading: true, error: null };
    case STUDENT_SET_MCQ_QUESTIONS: {
      const p = action.payload || {};
      return {
        ...state,
        loading: false,
        error: null,
        mcqQuestions: p.content || [],
        currentPage: p.number ?? 0,
        totalPages: p.totalPages ?? 0,
        size: p.size ?? 20,
        totalElements: p.totalElements ?? 0,
      };
    }
    case STUDENT_SET_MCQ_ERROR:
      return { ...state, loading: false, error: action.payload };

    // LESEN
    case STUDENT_SET_LESEN_LOADING:
      return { ...state, loading: true, error: null };
    case STUDENT_SET_LESEN_SUCCESS: {
      const d = action.payload || {};
      return {
        ...state,
        loading: false,
        error: null,
        lesenPassage: d,
        lesenQuestions: d.questions || [],
      };
    }
    case STUDENT_SET_LESEN_ERROR:
      return { ...state, loading: false, error: action.payload };

    // AUDIO
    case STUDENT_SET_AUDIO_LOADING:
      return { ...state, audioLoading: true, audioError: null };
    case STUDENT_SET_AUDIO_SUCCESS: {
      const p = action.payload || {};
      return {
        ...state,
        audioLoading: false,
        audioError: null,
        audioQuestions: p.content || [],
        audioPage: p.number ?? 0,
        audioTotalPages: p.totalPages ?? 0,
        audioSize: p.size ?? 20,
        audioTotalElements: p.totalElements ?? 0,
      };
    }
    case STUDENT_SET_AUDIO_ERROR:
      return { ...state, audioLoading: false, audioError: action.payload };

    // STATUS
    case STUDENT_SET_STATUS_LOADING:
      return { ...state, statusLoading: true, statusError: null };
    case STUDENT_SET_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        statusError: null,
        status: action.payload || initialState.status,
      };
    case STUDENT_SET_STATUS_ERROR:
      return { ...state, statusLoading: false, statusError: action.payload };

    case STUDENT_SET_BUNDLE_LOADING:
      return { ...state, bundleLoading: true, bundleError: null };
    case STUDENT_SET_BUNDLE_SUCCESS:
      return { ...state, bundleLoading: false, bundleError: null, bundle: action.payload };
    case STUDENT_SET_BUNDLE_ERROR:
      return { ...state, bundleLoading: false, bundleError: action.payload };

    default:
      return state;
  }
};

export default studentPlacementReducer;
